import {ajax, getRequestUrl, uploadImg, uploadFile} from "../request";

export default {
  //金币管理
  SendCoinsList(data, method) {
    return ajax('post', getRequestUrl('/assets/sendGoldList'), data, {
      method,
    })
  },

  sendGoldAgain(data, method) {
    return ajax('post', getRequestUrl('/assets/sendGoldAgain'), data, {
      method,
    })
  },

  SendCoinsExcel(data, method) {
    return uploadFile(getRequestUrl('/assets/preBatchSendGold'), data)
  },

  SendCoinsToMember(data, method) {
    return ajax('post', getRequestUrl('/assets/realBatchSendGold'), data, {
      method,
    })
  },

  propList(data, method) {
    return ajax('post', getRequestUrl('/prop/sendHistory'), data, {
      method,
    })
  },

  sendProp(data, method) {
    return ajax('post', getRequestUrl('/prop/realBatchSendProp'), data, {
      method,
    })
  },
  sendPropAgain(data, method) {
    return ajax('post', getRequestUrl('/prop/sendPropAgain'), data, {
      method,
    })
  },

  SendPropExcel(data) {
    return uploadFile(getRequestUrl('/prop/preBatchSendProp'), data)
  },

  coinDeleteList(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/coinDeleteList'), data, {
      method,
    })
  },

  confirmDeleteSend(data, method) {
    return ajax('post', getRequestUrl('/api/SendCoins/confirmDeleteSend'), data, {
      method,
    })
  },

  SendDeleteCoinExcel(data) {
    return uploadImg(getRequestUrl('/api/SendCoins/SendDeleteCoinExcel'), data)
  },

  roomMedalBatchList(data,method) {
    return ajax('post', getRequestUrl('/api/SendCoins/roomMedalBatchList'), data, {
      method,
    })
  },

  roomMedalBatch(data,method) {
    return ajax('post', getRequestUrl('/api/SendCoins/roomMedalBatch'), data, {
      method,
    })
  },

  updateUserLevelExcel(data,method) {
    return uploadImg(getRequestUrl('/api/SendCoins/updateUserLevelExcel'), data)
  },

  updateUserLevel(data,method) {
    return ajax('post', getRequestUrl('/api/SendCoins/updateUserLevel'), data, {
      method,
    })
  },

  sendFuelList(data,method) {
    return ajax('post', getRequestUrl('/assets/sendFuelList'), data, {
      method,
    })
  },
  sendFuel(data,method) {
    return ajax('post', getRequestUrl('/assets/sendFuel'), data, {
      method,
    })
  },
  SendFuelExcel(data, method) {
    return uploadFile(getRequestUrl('/assets/preBatchSendFuel'), data)
  },
  sendFuelBatch(data,method) {
    return ajax('post', getRequestUrl('/assets/realBatchSendFuel'), data, {
      method,
    })
  },
}



// WEBPACK FOOTER //
// ./src/js/https/sengCoins.js